import {
  Invite_InviteUserInput,
  useInvitePersonMutation
} from 'generated/graphql';
import { appFormUtil } from 'modules/common';
import React, { useEffect } from 'react';

type IFormState = {
  projectId: string;
  roleId: string;
  email: string;
  firstName: string;
  lastName: string;
};

const initialState: IFormState = {
  projectId: '',
  roleId: '',
  email: '',
  firstName: '',
  lastName: ''
};

export function useFormState(projectId: string) {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      projectId: {
        label: 'projectId',
        type: 'text'
      },
      roleId: {
        label: 'Project Role',
        type: 'button',
        required: true
      },
      email: {
        label: 'Email',
        type: 'email',
        required: true
      },
      firstName: {
        label: 'First Name',
        type: 'text',
        required: true
      },
      lastName: {
        label: 'Last Name',
        type: 'text',
        required: true
      }
    }
  });

  useEffect(() => {
    if (formState.projectId === '' && projectId !== '') {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'projectId',
          value: projectId
        }
      });
    }
    return () => {};
  }, [
    dispatch,
    formState.projectId,
    projectId
  ]);

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}


export function useInvitePerson() {
  const [
    fnMutate,
    tuple
  ] = useInvitePersonMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: Invite_InviteUserInput) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
